import React, { useEffect,useState } from 'react';
import { Alert } from 'components/common';
import { useProject } from 'components/hooks';
import { ROUTES } from 'consts';
import { scmType } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { ProjectSchema } from 'schemas';
import ProjectFormDumb from './ProjectFormDumb';


const ProjectCreateSmart = () => {
  const history = useHistory();
  const { cleanUpMessage, error, success, postProject } = useProject();
  const [foulderError, setFoulderError] = useState(false);

  const defaultValues = {
    name: '',
    description: '',
    company: '',
    scmType: scmType[0].value,
    folder: '',
    scmUrl: '',
    scmBranch: '',
    scmRefspec: '',
    credential: '',
    clean: false,
    deleteOnUpdate: false,
    allowBranchOverride: false,
  };

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    const proyect = new ProjectSchema();    
    proyect.setValues(data);    
    postProject({ 
      body: proyect.getValues(),
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.PROJECT_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);


  useEffect(() => {
    if (error.post == -2){
      setFoulderError(true);
    }
    
  }, [error.post]);

  return (
    <>
      { <ProjectFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} />}
      
      {foulderError ? 
        <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.directory" />
       :
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />}
    </>
  );
};

export default withRequest(withRouter(ProjectCreateSmart));